/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import RegisterPrivacyPopup from '@/components/popup/register-privacy-popup.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'register-privacy-checkbox',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "input"
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var visibleMap = reactive({
            agreement: false
        });
        var agreementType = ref();
        var onOpenAgreement = function(type) {
            agreementType.value = type;
            visibleMap.agreement = true;
        };
        return {
            __sfc: true,
            emit: emit,
            visibleMap: visibleMap,
            agreementType: agreementType,
            onOpenAgreement: onOpenAgreement,
            RegisterPrivacyPopup: RegisterPrivacyPopup
        };
    }
});
